export type FrontClearanceSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export const MANUFACTURER_OPTIONS: FrontClearanceSelectOption[] = [
  { value: "1", labelKey: "MANUFACTURERS.DATA.MERCEDES" },
  { value: "2", labelKey: "MANUFACTURERS.DATA.MAN" },
];

export const MASTER_MODEL_OPTIONS: FrontClearanceSelectOption[] = [
  { value: "10", label: "ACTROS 25xxL 26T" },
  { value: "11", label: "FLL42 15T" },
];

export const DRIVER_CABIN_OPTIONS: FrontClearanceSelectOption[] = [
  { value: "רגיל", labelKey: "FRONT_CLEARANCE.DATA.DRIVER_CABIN.NORMAL" },
  { value: "שינה", labelKey: "FRONT_CLEARANCE.DATA.DRIVER_CABIN.SLEEPER" },
];

export const BODY_TYPE_OPTIONS: FrontClearanceSelectOption[] = [
  { value: "1", labelKey: "FRONT_CLEARANCE.DATA.BODY_TYPE.OPEN" },
];
